import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { fieldClasses, primaryButtonClasses } from '../../ui/styles';

type AltTextFormProps = { initial: string; onApply: (value: string) => void; onCancel: () => void };

/** Inline alt-text editor shown in place of the image toolbar's buttons; Enter applies, Escape cancels. */
export const AltTextForm = ({ initial, onApply, onCancel }: AltTextFormProps) => {
  const { t } = useTranslation('common');
  const [value, setValue] = useState(initial);

  return (
    <div className="flex items-center gap-1.5 p-1">
      <input
        autoFocus
        aria-label={t('editor.image.alt-text')}
        placeholder={t('editor.image.alt-text-placeholder')}
        className={`${fieldClasses} w-56`}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onApply(value.trim());
          }
          if (e.key === 'Escape') onCancel();
        }}
      />
      <button type="button" className={primaryButtonClasses} onClick={() => onApply(value.trim())}>
        {t('editor.toolbar.apply')}
      </button>
      <button type="button" className="text-pbk-14 text-text-2 cursor-pointer px-1" onClick={onCancel}>
        {t('editor.image.cancel')}
      </button>
    </div>
  );
};
